import * as React from 'react';
import { createContext, useContext } from 'react';

import type { Modules } from 'bundles/front-page/hooks/usePageContentQuery';
import usePageContentQuery from 'bundles/front-page/hooks/usePageContentQuery';

type FrontPageContentDataProviderContext = {
  modules?: Modules;
  loading: boolean;
};

const FrontPageContentDataContext = createContext<FrontPageContentDataProviderContext>({
  modules: undefined,
  loading: true,
});

const FrontPageContentDataProvider = ({ children }: React.PropsWithChildren) => {
  const { modules, loading } = usePageContentQuery();

  return (
    <FrontPageContentDataContext.Provider value={{ modules, loading }}>{children}</FrontPageContentDataContext.Provider>
  );
};

export const useFrontPageContentData = () => {
  return useContext(FrontPageContentDataContext);
};

export default FrontPageContentDataProvider;
